export class CatalogHeaderModel {
}